<template>
    <div class="footer">
       <div class="concat">
           <!-- @click="modal1=true" -->
           <img src="@/assets/images/concat.jpg" alt="">
       </div>
       <div class="bottom">
           <div>
                <!-- <h3>义乌总部</h3> -->
                <p>华东总部：杭州市华成国际发展大厦1901-1902</p>
                <!-- <h3>华东总部</h3> -->
                <p>华南总部：广州市广州国际金融中心1802-1803</p>
                <!-- <h3>华南总部</h3> -->
                <p>仓储物流：义乌市丹溪北路728号熙美诚品</p>
                <!-- 4000 -->
                <!-- <h3>南京分公司</h3> -->
                <p>南京分公司：南京市锦绣街7号绿地之窗D4栋-418</p>
                <!-- <h3>成都分公司</h3> -->
                <p>成都分公司：成都市东御街19号茂业天地3807室</p>
                <!-- <h3>北京分公司</h3>
                <p>北京市通州区蓝调沙龙小区4号楼302室</p> -->
           </div>
           <div>
               <h3>供应商合作</h3>
               <p>电话：18102715189</p>
               <!-- <p>邮箱：22245727@qq.com</p> -->
           </div>
           <div>
               <img src="@/assets/images/LOGO.png" alt="">
               <h3>咨询电话：400-863-5888</h3>
               <p>@2019熙美诚品 版权所有 ALL Rights Reserved</p>
               <p>网站所属：{{content}}</p>
               <P>ICP号：{{icp}}</P>
           </div>
           <div style="font-size:12px;">
               <p>市场有风险，投资需谨慎</p>
               <!-- <p>数据来源于熙美诚品营销中心</p> -->
           </div>
       </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            // 是否显示弹出框
            // modal1:false,
            // 填写表单
            formValidate:{
                name: '',
                phone:'',
            },
            ruleValidate: {
                name: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                phone: [
                    {  type: 'number',required: true, message: '电话不能为空', trigger: 'blur' },
                ],
            },
            content:'广州熙彬贸易有限公司',
            icp:'粤ICP备17127451号-1'
        }
    },
    created(){
       this.change()
    },
    methods:{        
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        change(){
            console.log(location.href);
            if(location.href.includes('xmvogue')){
                this.content='广州熙彬贸易有限公司';
                this.icp='粤ICP备17127451号-1';
            }else if(location.href.includes('xmcpcn.com')){
                this.content='义乌楚睿电子商务有限公司';
                this.icp='浙ICP备13017989号-2'
            }else if(location.href.includes('4008635888') || location.href.includes('xmcpcn.cn')){
                this.content='浙江熙彬进出口有限公司';
                this.icp='浙ICP备18051049号-1'
            }
        }
    }
}
</script>







// WEBPACK FOOTER //
// src/components/footer.vue